/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-children-prop */
import React, { FC, useEffect, useState } from 'react';
import {
  Button,
  Container,
  CssBaseline,
  Grid,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useStyles from '../../../../assets/styles/pages/User';
import Header from '../../../../components/Header';
import { ItypeReturnApi } from '../../../../helpers/utils/TypeReturnApi';
import { api } from '../../../../services';
import { useSignInContext } from '../../../../providers/use-signin';
import FooterMenuMain from '../../../../components/FooterMenuMain';

import imgCashBack from '../../../../assets/images/tela_cashback.png';

import { FormatPriceInput } from '../../../../helpers/utils/Formating';
import ModalListCenter from '../../../../components/Modal/ListCenter';
import { getStorege } from '../../../../helpers/db_storage';

type CashBackProps = {
  dsFiltroOrigem: string;
  dsFiltroPagamento: string;
  flgAtivo: number;
  vlMinResgate: string;
  vlRetorno: string;
};

const CashBack: FC = () => {
  const classeStyle = useStyles();
  const navigate = useNavigate();
  const signData = useSignInContext();

  const [dataConfigCashback, setDataConfigCashback] = useState<CashBackProps>(
    {} as CashBackProps,
  );

  const [dataListShop, setDataListShop] = useState<any>([]);
  const [dataListPaymentFromat, setDataListPaymentFromat] = useState<any>([]);

  const [openModalListPaymentFormat, setOpenModalListPaymentFormat] =
    useState(false);
  const [openModalListShop, setOpenModalListShop] = useState(false);

  const [dataStorageCity, setDataStorageCity] = useState<any>('');

  const handleToPage = (url: string, replace = false): void => {
    return navigate(url, { replace });
  };

  const getConfigCashBack = async (): Promise<void> => {
    try {
      const result: ItypeReturnApi = await api.apiMaisdelivery.auth.cashBack({
        nr_operacao: 60,
        idMarketplace: dataStorageCity?.idMarketplace,
        idUsuario: signData.data?.user?.idUsuario,
      });

      setDataConfigCashback(result.data[0]);
    } catch (error) {
      toast.error('Ocorreu um erro, tente novamente mais tarde');
    }
  };

  const handleListShop = async (): Promise<void> => {
    try {
      const result: ItypeReturnApi = await api.apiMaisdelivery.auth.cashBack({
        nr_operacao: 61,
        idMarketplace: dataStorageCity?.idMarketplace,
        idUsuario: signData.data?.user?.idUsuario,
      });

      setDataListShop(result.data);
      setOpenModalListShop(true);
    } catch (error) {
      toast.error('Não foi possível buscar os estabelecimentos');
    }
  };

  const handleListPaymentFormat = async (): Promise<void> => {
    try {
      const result: ItypeReturnApi = await api.apiMaisdelivery.auth.cashBack({
        nr_operacao: 62,
        idMarketplace: dataStorageCity?.idMarketplace,
        idUsuario: signData.data?.user?.idUsuario,
      });

      setDataListPaymentFromat(result.data);
      setOpenModalListPaymentFormat(true);
    } catch (error) {
      toast.error('Não foi possível buscar as formas de pagamento');
    }
  };

  useEffect(() => {
    const dataUserStorage = getStorege('@mais/delivery/user');

    if (!dataUserStorage?.idUsuario) {
      toast.info(
        'Você precisa está logado para acessar o programa de recompensa.',
      );

      handleToPage('/fidelity', true);
    }
  }, []);

  useEffect(() => {
    const dataStorage = JSON.parse(
      localStorage.getItem('@mais/delivery/dataStateCity') as string,
    );
    setDataStorageCity(dataStorage);
  }, []);

  useEffect(() => {
    if (dataStorageCity) {
      getConfigCashBack();
    }
  }, [dataStorageCity]);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Header children="Cashback" />
      <CssBaseline />
      <Grid
        container
        item
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <img src={imgCashBack} alt="logo" className={classeStyle.imgCashBack} />
      </Grid>
      <Grid padding={2}>
        <Typography className={classeStyle.textFontSizeMin}>
          Ao utilizar nosso app, você não apenas adquire produtos e serviços
          excepcionais mas também recebe{' '}
          <b className={classeStyle.textNoBoldBackgroundColor}>
            {FormatPriceInput(dataConfigCashback.vlRetorno)}%
          </b>{' '}
          de Cashback no extrato da sua conta após a entrega do seu pedido.
        </Typography>
        <Typography marginTop={1} className={classeStyle.textFontSizeMin}>
          É como ganhar{' '}
          <b className={classeStyle.textNoBoldBackgroundColor}>Dinheiro</b>{' '}
          enquanto faz suas compras ;)
        </Typography>
        <Typography
          marginTop={1}
          onClick={handleListShop}
          className={classeStyle.textFontSizeMin}
        >
          Veja aqui os{' '}
          <b className={classeStyle.textNoBoldUnderlined}>Estabelecimentos</b>{' '}
          participantes.
        </Typography>
        <Typography
          marginTop={1}
          onClick={handleListPaymentFormat}
          className={classeStyle.textFontSizeMin}
        >
          Veja aqui as Formas de{' '}
          <b className={classeStyle.textNoBoldUnderlined}>Pagamento</b> aceitas.
        </Typography>
      </Grid>
      <Grid
        container
        item
        xs={12}
        justifyContent="center"
        style={{
          marginTop: 10,
          maxWidth: '680px',
          background: '#fff',
        }}
      >
        <Button
          variant="contained"
          className={classeStyle.btnSubmit}
          style={{ width: 'auto' }}
          onClick={() => handleToPage('/fidelity/extract')}
        >
          Extrato da Conta
        </Button>
      </Grid>
      <ModalListCenter
        isOpen={openModalListPaymentFormat}
        title="FORMAS DE PAGAMENTO"
        dataList={dataListPaymentFromat}
        handleFn={async () => setOpenModalListPaymentFormat(false)}
        onClose={() => setOpenModalListPaymentFormat(false)}
      />

      <ModalListCenter
        isOpen={openModalListShop}
        title="ESTABELECIMENTOS"
        dataList={dataListShop}
        handleFn={async () => setOpenModalListShop(false)}
        onClose={() => setOpenModalListShop(false)}
      />
      <FooterMenuMain children="fidelity" />
    </Container>
  );
};

export default CashBack;
